const $ = jQuery.noConflict();

class MobileHeader {
	constructor(
		trigger = '.btn-hamburger',
		pbody = 'body',
		listParent = '.menu-item-has-children > a'
	) {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
	}
	init() {
		$(this.trigger).on('click', this.setNavState);
		$(this.listParent).on('click', this.setListState);
		$(window).on('resize orientationchange', this.handleResize);
		$(window).resize(function () {
			if ($(window).width() > 1199) {
				$(this.listParent).on('click', this.setListState);
			}
		});
		$(window).on('load', () => {
			MobileHeader.calcMenuHeight();
		});

		// Tab hierarchy setup for a11y
		document.addEventListener('DOMContentLoaded', () => {
			const mobileMenu = document.querySelector('.main-header .main-header__nav-mobile--wrapper');
			const allLinks = mobileMenu.querySelectorAll('[id*="-menu-1"] a');

			allLinks.forEach(link => {
				link.ariaHidden = 'true';
				link.tabIndex = '-1';
			});

			allLinks[allLinks.length - 1].addEventListener('keydown', (e) => {
				if (e.key === "Tab") {
					e.preventDefault();
					const hamburger = document.querySelector('.main-header__mobile .btn-hamburger');
					hamburger.focus();
				}
			});
		});
	}
	setNavState(e) {
		e.preventDefault();
		const body = $('body');

		if ($(this).hasClass('open')) {
			MobileHeader.hideWrapper(this, body);
		} else {
			MobileHeader.showWrapper(this, body);
			MobileHeader.calcMenuHeight();
		}

		// Tab hierarchy setup for a11y
		const topLevelLinks = this.nextElementSibling.querySelectorAll('[id*="-menu-1"] > li > a');

		if (this.classList.contains('open')) {
			topLevelLinks.forEach(link => {
				link.ariaHidden = 'false';
				link.tabIndex = '0';
			});
		} else {
			topLevelLinks.forEach(link => {
				link.ariaHidden = 'true';
				link.tabIndex = '-1';
			});
		}
	}
	setListState(e) {
		e.preventDefault();
		
		const subMenuList = e.target.nextElementSibling;
		const subMenuItems = [...subMenuList.children];
		let subMenuHeight = 0;

		// Tab hierarchy setup for a11y
		const subLinks = this.nextElementSibling.querySelectorAll('a');

		if (!this.classList.contains('open')) {
			subLinks.forEach(link => {
				link.ariaHidden = 'false';
				link.tabIndex = '0';
			});
		}
		else {
			subLinks.forEach(link => {
				link.ariaHidden = 'true';
				link.tabIndex = '-1';
			});
		}

		if (!$(this).hasClass('open')) {
			$(this).addClass('open');
			if ($(window).width() < 1200) {
				subMenuItems.forEach(item => {
					subMenuHeight += item.clientHeight;
				});

				subMenuList.style.height = `${subMenuHeight}px`;
			} else {
				subMenuList.style.height = 'auto';
			}
		} else {
			$(this).removeClass('open');

			if ($(window).width() < 1200) {
				subMenuList.style.height = '0';
			} else {
				subMenuList.style.height = 'auto';
			}
		}
	}
	static calcMenuHeight() {
		let viewportHeight;
		if (window.visualViewport && window.visualViewport.height) {
			viewportHeight = window.visualViewport.height;
		} else {
			viewportHeight = $(window).height();
		}
		const headerHeight = $('header.main-header').outerHeight();
		$('.main-header__nav-mobile--wrapper').height(viewportHeight - headerHeight);
	}
	handleResize() {
		MobileHeader.calcMenuHeight();
	}
	static hideWrapper(el, body) {
		const mainElement = $('#page > .content-wrapper')[0];
		if (! mainElement) {
			const mainElements = $('#page > *:not(header):not(footer):not(.mega-menu-background)');
			mainElements.each(function () {
				this.style.transform = null;
			});
		}
		else {
			mainElement.style.transform = null;
		}
		
		if ($(window).width() < 1200) {
			$(".menu-item-has-children > a").siblings().css("height", "0");
		}
		else {
			$(".menu-item-has-children > a").siblings().css("height", "auto");
		}
		
		$(".menu-item-has-children > a").removeClass('open');
		$(el).removeClass('open');
		body.removeClass('overlayed');
		body.removeClass('lock-scroll');
		$(el).next().removeClass('active');
	}
	static showWrapper(el, body) {
		const mobileMenu = $('.main-header__nav-mobile--wrapper')[0];
		const mainElement = $('#page > .content-wrapper')[0];
		if (! mainElement) {
			const mainElements = $('#page > *:not(header):not(footer):not(.mega-menu-background)');
			mainElements.each(function () {
				this.style.transform = 'translateX(-' + mobileMenu.clientWidth + 'px)';
			});
		}
		else {
			mainElement.style.transform = 'translateX(-' + mobileMenu.clientWidth + 'px)';
		}

		MobileHeader.hideMobileSearch();
		$(el).addClass('open');
		body.addClass('overlayed');
		body.addClass('lock-scroll');
		$(el).next().addClass('active');
	}
	static hideMobileSearch () {
		$('.btn-search').removeClass('open');
		$('.search-wrapper').removeClass('active');
		$('.search-wrapper').hide();
		$('.btn-search .icon').addClass("icon-search");
		$('.btn-search .icon').removeClass("icon-close");
		$('.mega-menu-background').removeClass('active');
	}
	resized() {
		if (
			!$(this.trigger).is(':visible') &&
			$(this.trigger).hasClass('open')
		) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
	}
	hideOutsideClick(e) {
		if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {

			const container = $('.main-header');
			const cookieBar = $('#site-cookie-bar');

			if (
				!container.is(e.target) &&
        container.has(e.target).length === 0 &&
        !cookieBar.is(e.target) &&
        cookieBar.has(e.target).length === 0
			) {
				MobileHeader.hideWrapper(this.trigger, $(this.pbody));
			}
		}
	}
}

export default MobileHeader;
